function noop() { }

export { noop };
